<template>
  <div class='openlaunchapp-wrap'>
    这里是跳转小程序测试页面
    <div class="btn-box">
      <wx-open-launch-weapp id="launch-btn" appid="wx7605335e224edc7b" path="pages/index/index">
        <script type="text/wxtag-template">
          <style>.btn { padding: 12px }</style>
          <button class="btn">打开猛犸充电小程序</button>
        </script>
      </wx-open-launch-weapp>
    </div>
  </div>
</template>

<script>
import { wxConfigFun } from '../utils/wxConfig'

export default {
  components: {},
  data() {
    return {

    }
  },
  created() {
    wxConfigFun();
  },
  mounted() {
    console.log('---进入mounted了---')
    var btn = document.getElementById('launch-btn');
    btn.addEventListener('launch', function (e) {
      console.log('success--', e);
    });
    btn.addEventListener('error', function (e) {
      console.log('fail--', e.detail);
    });
  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
.openlaunchapp-wrap{
  height: 100%;
  .btn-box{
    width: 6.9rem;
    height: 3rem;
    background: #eee;
    margin: 0 auto;
  }
}
</style>